import React from 'react';
import { Grid } from '@mui/material';
import {
  BooleanInput,
  ArrayInput,
  SimpleFormIterator,
  DateInput,
  TextInput,
  RadioButtonGroupInput,
  NumberInput,
  useRecordContext,
  required,
} from 'react-admin';
import { SupplierInput } from '../Inputs/SupplierInput';

export const CourseCityDateInputs = ({
  getSource = null,
  scopedFormData,
  company = null,
  companySupplier = null,
  initializeSupplier = false,
}) => {
  const record = useRecordContext();

  const format = (v) => {
    console.log('v', v);
    console.log('form', scopedFormData['dateType']);

    if (typeof v === 'string') {
      return v;
    }

    if (typeof v === 'undefined') {
      return 'normalDate';
    }

    let dateTypeValue = 'normalDate';
    dateTypeValue =
      v.guaranteedDate === true ? 'guaranteedDate' : dateTypeValue;
    dateTypeValue = v.expectedDate === true ? 'expectedDate' : dateTypeValue;
    dateTypeValue = v.planedDate === true ? 'planedDate' : dateTypeValue;

    console.log('val', dateTypeValue);

    return dateTypeValue;

  };

  const getDefaultDateType = (record) => {
    if (record?.dataType === "guaranteedDate") return "guaranteedDate";
    if (record?.dataType === "expectedDate") return "expectedDate";
    if (record?.dataType === "planedDate") return "planedDate";
    return "normalDate";
  };

  return (
    <Grid container spacing={2} sx={{ p: 0 }}>
      <Grid item xs={3}>
        <DateInput
          required
          validate={required()}
          fullWidth
          source={getSource !== null ? getSource('startDate') : 'startDate'}
          record={scopedFormData ? scopedFormData['startDate'] : undefined}
          id="startDate"
        />
        <DateInput
          fullWidth
          source={getSource !== null ? getSource('showUntil') : 'showUntil'}
          record={scopedFormData ? scopedFormData['showUntil'] : undefined}
          id="showUntil"
        />
      </Grid>
      <Grid item xs={3}>
        <DateInput
          required
          validate={required()}
          fullWidth
          source={getSource !== null ? getSource('endDate') : 'endDate'}
          record={scopedFormData ? scopedFormData['endDate'] : undefined}
          id="endDate"
        />
        <NumberInput
          fullWidth
          source={getSource !== null ? getSource('price') : 'price'}
          record={scopedFormData ? scopedFormData['price'] : undefined}
          id="price"
        />
        <NumberInput
          fullWidth
          source={getSource !== null ? getSource('taxPercentage') : 'taxPercentage'}
          record={scopedFormData ? scopedFormData['taxPercentage'] : undefined}
          id="taxPercentage"
        />
        <NumberInput
          fullWidth
          source={
            getSource !== null
              ? getSource('additionalCosts')
              : 'additionalCosts'
          }
          record={scopedFormData ? scopedFormData['additionalCosts'] : undefined}
          id="additionalCosts"
        />
      </Grid>
        <Grid item xs={3}>
            <RadioButtonGroupInput
                source={getSource?.("dateType") || "dateType"}
                choices={[
                    { id: "normalDate", name: "Normal Date" },
                    { id: "guaranteedDate", name: "Guaranteed Date" },
                    { id: "expectedDate", name: "Expected Date" },
                    { id: "planedDate", name: "Planed Date" },
                ]}
                defaultValue={getDefaultDateType(record)}
                parse={(value) => {
                    return value;
                }}
                format={(value) => value || "normalDate"}
            />
        </Grid>
      <Grid item xs={3}>
        <RadioButtonGroupInput
          required
          optionValue={'value'}
          defaultValue={true}
          source={getSource !== null ? getSource('onDemand') : 'onDemand'}
          record={scopedFormData?.onDemand}
          parse={(v) => JSON.parse(v)}
          choices={[
            { id: 'no', name: 'Buchen', value: false },
            { id: 'yes', name: 'unverb. Anfrage', value: true },
          ]}
          id="onDemand"
        />
        <RadioButtonGroupInput
          required
          optionValue={'value'}
          defaultValue={true}
          source={getSource !== null ? getSource('onlinePurchasable') : 'onlinePurchasable'}
          record={scopedFormData?.onDemand}
          parse={(v) => JSON.parse(v)}
          choices={[
            { id: 'no', name: 'No', value: false },
            { id: 'yes', name: 'Yes', value: true },
          ]}
          id="onlinePurchasable"
        />
      </Grid>
      <Grid item xs={3}>
        <NumberInput fullWidth source={getSource !== null ? getSource('freeSpace') : 'freeSpace'}
                     record={scopedFormData ? scopedFormData['freeSpace'] : undefined}
        />
      </Grid>
      <Grid item xs={3}>
        <SupplierInput
          company={company}
          companySupplier={companySupplier}
          currentSupplier={scopedFormData?.supplier}
          initializeDefault={initializeSupplier}
          source={getSource !== null ? getSource('supplier') : 'supplier'}
        />
      </Grid>
      <Grid item xs={6}>
        <ArrayInput
          label="Zeiten"
          source={
            getSource !== null ? getSource('teachingTimes') : 'teachingTimes'
          }
          record={scopedFormData ? scopedFormData['teachingTimes'] : undefined}
          defaultValue={[]}
          id="teachingTimes"
        >
          <SimpleFormIterator>
            <TextInput source="time" />
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </Grid>
  );
};
